import { Component, Input } from '@angular/core';
import { ConstructionDocumentsResponse } from '../../entities/construction-documents-entities';

@Component({
  selector: 'app-folder-content-wrapper',
  templateUrl: './folder-content-wrapper.component.html',
  styleUrl: './folder-content-wrapper.component.scss',
  standalone: false,
})
export class FolderContentWrapperComponent {
  @Input() isMobileScreen: boolean;
  @Input() data: ConstructionDocumentsResponse;
}
